import { Injectable } from '@angular/core';
import { ReportLaunchServiceBase } from './report-launch.service.base';
import { ReportDesignerPayload } from './report-payload.protocol';

export type { ReportDesignerPayload } from './report-payload.protocol';

@Injectable({ providedIn: 'root' })
export class ReportDesignerLaunchService extends ReportLaunchServiceBase {
  open(payload: ReportDesignerPayload): boolean {
    return this.openReportWindow('designer', 'report-designer', payload);
  }
}
